export default __webpack_public_path__ + "static/media/shrink.e399941b.svg";